import { render, staticRenderFns } from "./AddInPPTModal.vue?vue&type=template&id=090226ca&scoped=true&"
import script from "./AddInPPTModal.vue?vue&type=script&lang=js&"
export * from "./AddInPPTModal.vue?vue&type=script&lang=js&"
import style0 from "./AddInPPTModal.vue?vue&type=style&index=0&id=090226ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090226ca",
  null
  
)

export default component.exports